// extracted by mini-css-extract-plugin
module.exports = {"circlegif":"AuthForm_circlegif__fDpti","circleText":"AuthForm_circleText__1V2Jk"};